@if (!tariff.availability.isAvailable || tariff.availability.reason) {
  <notification theme="attention">
    {{ tariff.availability.reason }}
  </notification>
}
<form (ngSubmit)="formSubmit()" [formGroup]="accountForm" novalidate>
  @if (!!tariff) {
    @if (isProfessional) {
      <pac-alert
        type="info"
        [iconCentered]="true"
        title="register-account.alert.deposit.pro"
        class="alert-top"
      ></pac-alert>
    }
    <div class="row-flex-grid row-flex-grid__m-15">
      @if ({ focus: false, control: accountForm.get('server'), field: 'server' }; as ctx) {
        <div>
          <div class="m-bottom">
            <div class="hint-wrap">
              <label
                translate="open-account.field.server"
                matTooltipPosition="above"
                [matTooltip]="'open-account.tooltip.server' | translate"
              ></label>
              <div
                class="account-settings__hint"
                matTooltipPosition="above"
                [matTooltip]="'open-account.tooltip.server' | translate"
                >
                <svg-icon-sprite
                  class="account-settings__hint-ico"
                  width="16"
                  height="16"
                  [src]="'./assets/img/icons/sprite.svg#hint'"
                ></svg-icon-sprite>
              </div>
            </div>
            @if (tariff.servers) {
              <div class="b-style p-tb15 p-lr25">
                <app-form-field
                  type="custom"
                  class="server"
                  [isControlTouched]="ctx.control.touched"
                  [errors]="ctx.control.errors"
                  [errorTexts]="fieldErrors(ctx.field)"
                  [submitErrors]="submitErrors.asObservable()"
                  >
                  <div class="acc-form-row" [class.acc-form-row--multi]="tariff.servers.length > 1" [class.acc-form-row--server]="!isEveryServerEnabled(tariff)">
                    @for (server of tariff.servers; track server) {
                      <div
                        class="acc-form-row__field acc-form-row__field--server"
                        [class.p-tb10]="server.isEnabled"
                        [class]="'server-name--' + server.name"
                        >
                        @if (server.isEnabled) {
                          <div
                            class="radio radio-inner"
                            [class.radio--fake]="tariff.servers.length === 1"
                            >
                            <input
                              [attr.data-qa]="'account-opening.open-account.metatrader_version_' + server.name.slice(2)"
                              [attr.data-e2e-element]="'account-create.server.' + server.name"
                              class="radio__input radio-inner__input"
                              type="radio"
                              [value]="server.name"
                              formControlName="server"
                              [attr.disabled]="disableExceptPreSelectedServer && server.name !== preSelectedServer ? true : null"
                              />
                            <div class="radio__fill radio-inner__fill"></div>
                            <div class="radio__info radio-inner__info">
                              <span [translate]="'open-account.label.' + server.name"></span>
                            </div>
                          </div>
                        } @else {
                          <div class="without-radio">
                            <span class="without-radio__title" [translate]="'open-account.label.' + server.name"></span>
                            <span class="without-radio__info">{{ server.reason }}</span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </app-form-field>
              </div>
            }
          </div>
        </div>
      }
      @if ({ focus: false, control: accountForm.get('currency'), field: 'currency' }; as ctx) {
        <div>
          <div class="m-bottom">
            <div class="p-b10">
              <label translate="open-account.field.currency"></label>
            </div>
            @if (tariffCurrencies(tariff)) {
              <div class="b-style p-tb15 p-lr25">
                <app-form-field
                  type="custom"
                  class="currency"
                  [isControlTouched]="ctx.control.touched"
                  [errors]="ctx.control.errors"
                  [errorTexts]="fieldErrors(ctx.field)"
                  [submitErrors]="submitErrors.asObservable()"
                  >
                  <div class="acc-form-row acc-form-row--multi">
                    @for (currency of tariffCurrencies(tariff); track currency) {
                      <div class="acc-form-row__field p-tb10">
                        <div class="radio radio-inner" [class.radio--fake]="tariffCurrencies(tariff).length === 1">
                          <input
                            [attr.data-qa]="'account-opening.open-account.account_currency_' + currency"
                            [attr.data-e2e-element]="'account-create.currency.' + currency"
                            class="radio__input radio-inner__input"
                            type="radio"
                            [value]="currency"
                            formControlName="currency"
                            name="currency"
                            />
                          <div class="radio__fill radio-inner__fill"></div>
                          <div class="radio__info radio-inner__info">
                            <span class="">{{ currency }}</span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </app-form-field>
              </div>
            }
          </div>
        </div>
      }
      @if (tariff.isDemo) {
        <div>
          <div class="m-bottom">
            <div class="p-b10">
              <label for="amount" translate="open-account.field.amount"></label>
            </div>
            <div class="b-style p-tb12 p-lr25">
              @if ({ focus: false, control: accountForm.get('amount'), field: 'amount' }; as ctx) {
                <app-form-field
                  type="custom"
                  class="acc-form-field amount"
                  [isControlTouched]="ctx.control.touched"
                  [errors]="ctx.control.errors"
                  [errorTexts]="fieldErrors(ctx.field)"
                  [errorParams]="{ max: maxDemoAmount.toLocaleString() }"
                  [submitErrors]="submitErrors.asObservable()"
                  >
                  <input
                    type="text"
                    inputmode="decimal"
                    class="acc-form-field__input"
                    id="amount"
                    formControlName="amount"
                    autocomplete="off"
                    name="amount"
                    [maskito]="maskOptions"
                    (focus)="ctx.focus = true"
                    (blur)="ctx.focus = false"
                    [placeholder]="ctx.focus ? '' : ('open-account.placeholder.amount' | translate)"
                    />
                </app-form-field>
              }
            </div>
          </div>
        </div>
      }
    </div>
    @if (isSwapFreeContentVisible) {
      <div>
        @if ({
          focus: false,
          control: accountForm.get('isSwapFreeEnabled'),
          field: 'isSwapFreeEnabled'
          }; as ctx) {
          <app-form-field
            type="custom"
            class="m-bottom"
            [isControlTouched]="ctx.control.touched"
            [errors]="ctx.control.errors"
            [errorTexts]="fieldErrors(ctx.field)"
            [submitErrors]="submitErrors.asObservable()"
            >
            <div class="b-style p-tb15 p-lr25 account-settings__swap-free-trigger">
              <div class="hint-wrap">
                <label
                  class="mdc-label"
                  [translate]="isIslamicCountry ? 'account.label.islamic' : 'account.label.swapfree'"
                  matTooltipPosition="above"
                  [matTooltip]="'account.tooltip.swapfree' | translate"
                ></label>
                <div
                  class="account-settings__hint"
                  matTooltipPosition="above"
                  [matTooltip]="'account.tooltip.swapfree' | translate"
                  >
                  <svg-icon-sprite
                    class="account-settings__hint-ico"
                    width="16"
                    height="16"
                    [src]="'./assets/img/icons/sprite.svg#hint'"
                  ></svg-icon-sprite>
                </div>
              </div>
              <toggler
                [checked]="!!accountForm.value.isSwapFreeEnabled"
                (changed)="changeSwapFreeStatus()"
              ></toggler>
            </div>
            @if (accountForm.value.isSwapFreeEnabled) {
              <pac-alert
                type="info"
                [iconCentered]="true"
                [description]="swapFreeDescription"
                class="account-settings__swap-free-alert"
              ></pac-alert>
            }
          </app-form-field>
        }
      </div>
    }
    @if (canUseFixRate(tariff)) {
      <div class="m-bottom acc-form-field__fixrate">
        <div class="hint-wrap p-tb10">
          <label class="mdc-label" translate="open-account.field.fixRate"></label>
        </div>
        <div class="b-style p-tb15 p-lr25">
          @if ({ focus: false, control: accountForm.get('fixRate'), field: 'fixRate' }; as ctx) {
            <div class="acc-form-field__fixrate-info">
              <app-form-field
                type="checkbox"
                [isControlTouched]="ctx.control.touched"
                [errors]="ctx.control.errors"
                [errorTexts]="fieldErrors(ctx.field)"
                [submitErrors]="submitErrors.asObservable()"
                >
                <mat-checkbox formControlName="fixRate" class="form-control">
                  <span
                    class="checkboxCurrent__label"
                    translate="open-account.tooltip.fixRate"
                    [translateParams]="{ rate: fixedRate, currency: fixRateCurrency }"
                  ></span>
                </mat-checkbox>
              </app-form-field>
            </div>
          }
        </div>
      </div>
    }
    @if ({ focus: false, control: accountForm.get('leverage'), field: 'leverage' }; as ctx) {
      <app-form-field
        type="custom"
        class="m-bottom"
        [isControlTouched]="ctx.control.touched"
        [errors]="ctx.control.errors"
        [errorTexts]="fieldErrors(ctx.field)"
        [submitErrors]="submitErrors.asObservable()"
        >
        <div class="hint-wrap">
          <label
            translate="open-account.field.leverage"
            matTooltipPosition="above"
            [matTooltip]="'open-account.tooltip.leverage' | translate"
          ></label>
          <div
            class="account-settings__hint"
            matTooltipPosition="above"
            [matTooltip]="'open-account.tooltip.leverage' | translate"
            >
            <svg-icon-sprite
              class="account-settings__hint-ico"
              width="16"
              height="16"
              [src]="'./assets/img/icons/sprite.svg#hint'"
            ></svg-icon-sprite>
          </div>
        </div>
        <div class="b-style p-tb15 p-lr25">
          <div class="acc-form-leverage">
            <div class="acc-form-row acc-form-row__leverage">
              @for (leverage of leverages; track leverage) {
                <div class="acc-form-row__field acc-form-row__field-leverage">
                  <div class="acc-form-row__field-leverage-content">
                    <div class="radio radio-inner">
                      <input
                        data-qa="account-opening.open-account.leverage"
                        [attr.data-e2e-element]="'account-create.leverage.' + leverage"
                        class="radio__input radio-inner__input"
                        type="radio"
                        [value]="leverage"
                        formControlName="leverage"
                        name="leverage"
                        />
                      <div class="radio__fill radio-inner__fill"></div>
                      <div class="radio__info radio-inner__info">1:<bdi>{{ leverage }}</bdi></div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </app-form-field>
    }
    <div class="actions-wrapper actions-wrapper--column">
      @if (tariff.availability.isAvailable) {
        <btn
          data-qa="account-opening.open-account.button"
          type="submit"
          buttonText="open-account.label.open-account"
          data-e2e-element="button.open-account"
        ></btn>
      }
      <a class="link button--link" (click)="back()" translate="open-account.label.back"></a>
    </div>
  }
</form>
